<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.kategori.liste.baslikH1")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :lg="16" :md="16" :sm="24" :xs="24">
                <div>
                    <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-page-next mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">Yayındaki Kategoriler</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-page-next mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">Pasif Kategoriler</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-table
                    border
                    stripe
                    :data="kategoriList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="dil.de.baslik"
                        label="Başlık (Almanca)"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="dil.en.baslik"
                        label="Başlık (İngilizce)"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="200">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="routeUrun('Kategori Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.urun.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1'"
                                    class="buttonDel"
                                    type="text"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content='Yayına Al' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0'"
                                    @click="kategoriDurumChange(scope.row,scope.$index,kategoriList,1)"
                                    type="text"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' ürün kategorisini taslağa atmak istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="kategoriDurumChange(selection,selectionIndex,kategoriList,0), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'
    import EventBus from '@/components/event-bus'

    let base64 = require('base64_js');
    let userDataKader = "";

    export default {
        name: "Kategoriistesi",
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                pathh: urunService.path,
                kategoriList: [],
                urunlarListTaslak: [],
                deleteDialogVisible: false,
                taslakDialogVisible: false,
                selection: '',
                selectionIndex: '',
                root : false,
                yetkiList: {
                    urunKategoriGuncelle: false,
                    urunKategoriDurumDegis: false,
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataKader")) {
                userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
                if (userDataKader["tur"]) {
                    if (userDataKader["tur"] === '1') {
                        self.root = true;
                        self.yetkiList.urunKategoriDurumDegis = true;
                        self.yetkiList.urunKategoriGuncelle = true;
                    }
                }
                if (userDataKader["yetki"]) {
                    userDataKader["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-482800':
                                self.yetkiList.urunKategoriGuncelle = true;
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                            case 'YK-462516':
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                        }
                    });
                }

            }
            EventBus.$on('ukategoriList', function(bool){
                if(bool){
                    self.getKategoriList();
                }
            });
            this.getKategoriList();

        },
        methods: {
            handleChange(event) {
                this.selectIcon = event;
                this.getKategoriList();
            },
            routeUrun(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.ukategoriId);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getKategoriList() {
                let self = this;
                urunService.ukategoriList(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        self.kategoriList= response.data;
                    }
                })
            },
            kategoriDurumChange(selection, index, list, durum) {
                urunService.ukategoriDurumGuncelle(selection.ukategoriId, durum).then((response) => {
                    if (response.status === 200) {
                        list.splice(index, 1);
                        notification.Status('success', this, "Kategori durumu başarıyla güncellendi.")
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>
